import React, {Component} from 'react';
import * as THREE from "three";
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import './index.css';

class BrainCanvas extends Component {

    clock = new THREE.Clock();
    mixer;
    brainMesh;
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        0.1,
        1000
    );
    renderer = new THREE.WebGLRenderer({ alpha: true });

    componentDidMount() {

        if (window.innerWidth < 500 || window.innerHeight < 500) {
            this.renderer.setSize( window.innerWidth, window.innerHeight/4 );
            this.camera = new THREE.PerspectiveCamera(
                75,
                window.innerWidth / window.innerHeight*4,
                0.1,
                1000
            );
        }
        else
        {
            this.renderer.setSize( window.innerWidth, window.innerHeight );
        }
        this.renderer.autoClear = false;
        this.renderer.setClearColor(0x000000, 0.0);
        this.mount.appendChild(this.renderer.domElement);

        // this.scene.background = new THREE.Color( 0xb30000 ); // #e60000

        /*    const textureLoader = new THREE.TextureLoader();
            textureLoader.load(backgroundImage , (texture) =>
            {
                this.scene.background = texture;
            });*/

        window.requestAnimationFrame(() => this.animate());

        // animate();

        const controls = new OrbitControls(this.camera, this.renderer.domElement);

        this.camera.position.z = 120;
        // this.camera.position.x = -50;
        /*const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
        hemiLight.position.set(0, 20, 0);
        this.scene.add(hemiLight);*/

        const dirLight = new THREE.DirectionalLight(0xffffff);
        dirLight.position.set(0, 0, -90);
        this.scene.add(dirLight);


        const ambient = new THREE.AmbientLight(0x404040, 2);
        this.scene.add(ambient);

        const light = new THREE.DirectionalLight(0xffffff, 2);
        light.position.set(50, 50, 100);
        this.scene.add(light);


        const loader = new GLTFLoader();

        loader.load(
            'https://onlineforms.kenes.com/assets/models/Brain/scene.gltf',
            // '../assets/models/Brain/scene.gltf',
            (gltf) => {

                this.brainMesh = gltf.scene;
                this.brainMesh.position.set(0, -20, 0);
                this.scene.add(this.brainMesh);

                const texture = new THREE.TextureLoader().load(
                    // './assets/models/' + item.textureFileName
                    'https://onlineforms.kenes.com/assets/models/Brain/textures/08_-_Default_baseColor.png',
                );
                texture.flipY = false;
                const material = new THREE.MeshPhongMaterial({
                    map: texture,
                    color: 0xffffff,
                    opacity: 0.7, transparent: true,
                    skinning: true
                });
                this.brainMesh.traverse(o => {
                    if (o.isMesh) {
                        o.castShadow = true;
                        o.receiveShadow = true;
                        o.material = material;
                    }
                });

                this.mixer = new THREE.AnimationMixer(gltf.scene);
                gltf.animations.forEach((clip) => {
                    this.mixer.clipAction(clip).play();
                });

            },
            (xhr) => {
                // called while loading is progressing
                // console.log(`${(xhr.loaded / xhr.total * 100)}% loaded`);
            },
            (error) => {

                // called when loading has errors
                console.error('An error happened', error);
            },
        );

        window.addEventListener( 'resize', this.onWindowResize, false );

    }

    onWindowResize = () => {

        if(this.renderer){
            if (window.innerWidth < 500 || window.innerHeight < 500) {
                if(this.camera){
                    this.camera.aspect = window.innerWidth / window.innerHeight*4;
                    this.camera.updateProjectionMatrix();
                }
                this.renderer.setSize( window.innerWidth, window.innerHeight/4 );
            }
            else
            {
                if(this.camera){
                    this.camera.aspect = window.innerWidth / window.innerHeight;
                    this.camera.updateProjectionMatrix();
                }
                this.renderer.setSize( window.innerWidth, window.innerHeight );
            }
        }
    }

    render() {
        return <div style={{background: "linear-gradient(#144395, #1A76B7)"}} ref={ref => (this.mount = ref)}/>;
    }

    animate() {

        window.requestAnimationFrame(() => this.animate());

        /*if (this.brainMesh) {
            this.brainMesh.rotation.x += 0.003;
            this.brainMesh.rotation.y += 0.003;
        }*/

        var delta = this.clock.getDelta();
        // console.log(delta);
        if (this.mixer) this.mixer.update(0.005);

        this.renderer.render(this.scene, this.camera);
    };

}

export default BrainCanvas;
